import actions from "../actions/actionTypes";

const initialState = {
  initializeResponse: {},
  fieldsResponse: null,
  formFields: null,
  currentState: null,
  currentWorkItem: null,
  canSave: false,
  onFieldsNext: false,
  nextSection: false,
  nextSectionMessage: "",
  miscFees: [],
  pre1981Data:[],
  enterDataManually:false,
  error: null
};

export default function workItemsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_INITIALIZE:
      return { ...state, currentState: null, fieldsResponse: null, miscFees:[], pre1981Data:[] };
    case actions.FETCH_INITIALIZE_SUCCESS:
      return { ...state, initializeResponse: action.payload };
    case actions.FETCH_INITIALIZE_FAILED:
      return { ...state, initializeResponse: {}, error: action.payload };
    case actions.FETCH_FIELDS_SUCCESS:
      return { ...state, fieldsResponse: action.payload };
    case actions.FETCH_FIELDS_FAILED:
      if (state.enterDataManually) {
        return { ...state, nextSection: true };
      }
      else {
        return { ...state};
      }
    case actions.SET_CURRENT_STATE:
      return { ...state, currentWorkItem: null, currentState: action.payload };
    case actions.SET_FORM_FIELDS:
          return { ...state, formFields: action.payload, };
    case actions.RESET_CURRENT_STATE:
      return { ...state, currentState: null };
    case actions.CHANGE_INPUT_VALUE:
      return { ...state, canSave: true };
    case actions.CREATE_WORK_ITEM:
      return { ...state, canSave: false };
    case actions.GENERATE_WORKITEM_REPORT_FAILED:
    case actions.CREATE_WORK_ITEM_FAILED:
      return { ...state, canSave: true, error: action.payload };
    case actions.UPDATE_WORKITEM:
      return { ...state, canSave: false, currentWorkItem: action.payload };
    case actions.CANCEL_WORKITEM:
      return {
        ...state,
        canSave: false,
        currentState: null,
        fieldsResponse: null,
        pre1981Data: []
      };
    case actions.SET_CURRENT_WORKITEM:
      return { ...state, currentWorkItem: action.payload };
    case actions.GENERATE_WORKITEM_REPORT_SUCCESS:
    case actions.CREATE_WORK_ITEM_SUCCESS:
      return {
        ...state,
        canSave: true,
        currentWorkItem: action.payload,
        fieldsResponse: null,
        error: null
      };
    case actions.RESET_ERROR:
      return { ...state, error: null };
    case actions.SHOW_FIELDS_LOADER:
      return { ...state, onFieldsNext: true, canSave: false };
    case actions.HIDE_FIELDS_LOADER:
      return { ...state, onFieldsNext: false, canSave: true };
    case actions.SHOW_NEXT_SECTION:
      return { ...state, nextSection: true };
    case actions.HIDE_NEXT_SECTION:
      return { ...state, nextSection: false };
    case actions.SECTION_MESSAGE:
          return { ...state, nextSectionMessage: action.payload };
    case actions.ENTER_DATA_MANUALLY:
          return { ...state, enterDataManually: action.payload }
    case actions.ADD_MISC_FEE:
      return { ...state, miscFees: action.payload };
    case actions.SET_MISC_FEE_VALUE:
      return { ...state, miscFees: action.payload };
    case actions.SET_PRE1981DATA_VALUE:
          return { ...state, pre1981Data: action.payload };
    case actions.ENEABLE_QUESTIONAIRE_BUTTONS:
          return { ...state, canSave: true };
    default:
      return state;
  }
}
